import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface SAPTableColumn {
  key: string;
  label: string;
  width?: string;
  align?: string;
  formatter?: (value: any) => string;
}

export interface SAPFetchResultData {
  title: string;
  isLoading: boolean;
  loadingMessage?: string;
  columns: SAPTableColumn[];
  rows: any[];
  totalRecords?: number;
}

@Component({
  selector: 'sap-fetch-result-dialog',
  templateUrl: './sap-fetch-result-dialog.html',
  styleUrls: ['./sap-fetch-result-dialog.css']
})
export class SAPFetchResultDialog implements OnInit {

  displayedColumns: string[] = [];
  columnDefinitions: SAPTableColumn[] = [];
  dataSource: any[] = [];

  isLoading: boolean = true;
  loadingMessage: string = 'Fetching SAP data, please wait...';
  title: string = 'SAP Data';
  totalRecords: number = 0;

  constructor(
    public dialogRef: MatDialogRef<SAPFetchResultDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SAPFetchResultData
  ) {

    if (data) {

      this.title = data.title || 'SAP Data';

      this.isLoading =
        data.isLoading !== undefined
          ? data.isLoading
          : true;

      this.loadingMessage =
        data.loadingMessage ||
        'Fetching SAP data, please wait...';

      this.columnDefinitions =
        data.columns || [];

      this.dataSource =
        data.rows || [];

      this.totalRecords =
        data.totalRecords ||
        (data.rows ? data.rows.length : 0);
    }
  }

  ngOnInit(): void {

    this.displayedColumns =
      this.columnDefinitions.map(
        col => col.key
      );
  }

  /**
   * Called by Planning and Logistics
   * after SAP response is received.
   */
  refreshData(rows: any[], totalRecords?: number): void {
  this.isLoading = false;
  this.dataSource = rows ? [...rows] : [];
  this.totalRecords = totalRecords || this.dataSource.length;
}

showError(): void {
  this.isLoading = false;
  this.dataSource = [];
  this.totalRecords = 0;
}

  getCellValue(
    row: any,
    column: SAPTableColumn
  ): string {

    const value = row[column.key];

    if (column.formatter) {
      return column.formatter(value);
    }

    return value != null
      ? value.toString()
      : '';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}